import merge from "../functions/merge";

export default {
	entity() {
		var valid_to = new Date();
		valid_to.setDate(valid_to.getDate() + 30);

		var next_contact = new Date();
		next_contact.setDate(next_contact.getDate() + 7);

		return merge({}, {
			_embedded: {
				contact: {
					name: '',
					address: '',
					zip: '',
					city: ''
				},
				employee: {
					name: ''
				},
				tasks: []
			},
	
			contact_id: null,
			department_id: null,
			employee_id: null,
	
			customer: {
				name: '',
				att: '',
				address: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				phone: '',
				email: '',
				numbers: {}
			},

			files: [],
			auto_gen: false,
	
			comments: '',
			description: '',
			remarks: '',
			remarks_all: '',
			order_lines: [],
			email_status: '',
			next_contact: next_contact.format('Y-m-d'),
			valid_to: valid_to.format('Y-m-d'),
			status: 'pending',


			template_id: null,
			template:{
				storage: 0,
				storage_vat: false,
				incl: [],
				extra: '',
				ps: ''
			},
		});
	},
	save(axios, entity) {
		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/sales/quotes/' + entity.id + '/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						
					});
			} else {
				axios
					.post('/sales/quotes/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		return new Promise(function (resolve) {
			axios
				.get('/sales/quotes/' + id + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/sales/quotes/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	}
};